import React from 'react';
import './ad.css';
import { logout } from "../slice/authSlice";
import { useDispatch } from 'react-redux';
import { MdLogout } from "react-icons/md";

export default function AdNav({ collapsed }) {
  const dispatch = useDispatch();


  const logoutHandler = async() => {
      await dispatch(logout());
  }
  return (
    <div className={`navbar-ad ${collapsed ? 'navbar-collapsed-ad' : ''}`}>
      <div className="navbar-left-ad">
        <span className="logo-ad">MyAdmin</span>
      </div>

      <div className="navbar-center-ad">
        <h2 className="page-title-ad">Dashboard</h2>
      </div>

      <div className="navbar-right-ad" onClick={logoutHandler}>
        <div className="avatar-ad"><MdLogout/></div>
      </div>
    </div>
  );
}
